import styled from 'styled-components'
import { Card, Collapse, Select } from 'antd'
import { IconFont, SignTitle, SvgIcon, TableTag } from '@/components'
import { useState } from 'react'
import ReactECharts from 'echarts-for-react'
import ModeCardPng from '@/assets/imges/data-protection/modecard.png'
import { TemplateParticulars } from '../create-task/template-particulars'
import { IDetailModal } from '../plan-list/plan-list-main'
import { compressTypeMap, fileTypeMap, leakTypeMap } from './detail'
import interrupt from '@/assets/imges/仪表盘任务中断状态.png'
import { t } from '@/i18n'

const TaskInfo = props => {
  const { taskInfo, changeDate, setRandom } = props
  const [collapse, setCollapse] = useState(['1'])
  const [detailModal, setDetailModal] = useState<IDetailModal>()
  const score = taskInfo?.score || 0
  const option1 = (values: { value; title: string }) => {
    let { value, title } = values
    return {
      series: [
        {
          type: 'gauge',
          min: 0,
          max: 100,
          splitNumber: 5,
          radius: '100%',
          axisLine: {
            lineStyle: {
              width: 12,
              color: [
                [0.4, '#b70100'],
                [0.6, '#ff3155'],
                [0.8, '#ffa70b'],
                [1, '#74a0fa'],
              ],
            },
          },
          pointer: {
            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
            length: '15%',
            width: 10,
            offsetCenter: [0, -45],
            itemStyle: {
              color: 'inherit',
            },
          },
          axisTick: {
            length: 5,
            lineStyle: {
              color: 'inherit',
              width: 1,
            },
            distance: 3,
          },
          splitLine: {
            length: 8,
            distance: 2,
            lineStyle: {
              color: 'inherit',
              width: 2,
            },
          },
          axisLabel: {
            color: '#666666',
            fontSize: 8,
            distance: 15,
          },
          title: {
            offsetCenter: [0, 20],
            fontSize: 16,
            color: 'inherit',
          },
          detail: {
            fontSize: 30,
            offsetCenter: [0, -20],
            valueAnimation: true,
            formatter: function (num) {
              return `${Math.round(num)}`
            },
            color: 'inherit',
          },
          data: [
            {
              value: value,
              name: title,
            },
          ],
        },
      ],
    }
  }
  return (
    <>
      <CollapsibleCard activeKey={collapse}>
        <Collapse.Panel
          header={
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                <SignTitle style={{ width: 200 }}>{taskInfo?.task_name}</SignTitle>
              </div>
              {collapse.length === 0 && (
                <div style={{ display: 'flex', width: '100%' }}>
                  <div style={{ width: 200, display: 'flex', alignItems: 'center' }}>
                    {t('任务进度：')}
                    <div>
                      {taskInfo?.scheduler_type === 1 && t('立即')}
                      {taskInfo?.scheduler_type === 2 && t('预定')}
                      {taskInfo?.scheduler_type === 3 && t('每日')}
                      {taskInfo?.scheduler_type === 4 && t('每周')}
                      {taskInfo?.scheduler_type === 5 && t('每月')}
                    </div>
                    {taskInfo?.is_finished !== 1 ? (
                      <TableTag
                        background="#e9f1ff"
                        color="#2973ff"
                        style={{ padding: '3px 6px', marginLeft: 10 }}
                      >
                        {t('进行中')}
                      </TableTag>
                    ) : (
                      <TableTag
                        background="#f2f9eb"
                        color="#67c23a"
                        style={{ padding: '3px 6px', marginLeft: 10 }}
                      >
                        {t('已完成')}
                      </TableTag>
                    )}
                  </div>
                </div>
              )}
            </div>
          }
          key="1"
          showArrow={false}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <TaskInfoContainer
              title={
                <div
                  style={{
                    paddingBottom: '7px',
                    borderBottom: '1px solid #EAEDF1',
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: '16px',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: -12 }}>
                    <SvgIcon width={16} height={16} name={'data-arrival'} fill={'#fff'} />
                    <div style={{ marginLeft: 5 }}>{t('任务信息')}</div>
                  </div>
                  {[3, 4, 5].includes(taskInfo?.scheduler_type) ? (
                    <div
                      style={{
                        fontSize: 13,
                        fontWeight: 400,
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '-12px',
                      }}
                    >
                      <div>{t('执行日期：')} </div>
                      <Select
                        getPopupContainer={node => node?.parentNode?.parentNode}
                        style={{ width: 180, marginRight: 10 }}
                        defaultValue={taskInfo?.execution_list?.[0]?.result_id}
                        onChange={val => {
                          changeDate(val)
                          setRandom(Math.random())
                        }}
                      >
                        {taskInfo?.execution_list?.map((item, index) => (
                          <Select.Option key={index} value={item.result_id}>
                            {item.create_time}
                          </Select.Option>
                        ))}
                      </Select>
                      <div
                        style={{
                          padding: '9px 4px',
                          background: '#ebeef7',
                          borderRadius: '4px',
                          color: '#666666',
                        }}
                      >
                        {taskInfo.order}/{taskInfo.total}
                      </div>
                    </div>
                  ) : (
                    <div style={{ height: '30px' }} />
                  )}
                </div>
              }
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ flex: 1 }}>
                  <div className="flex-column">
                    <div className="info">
                      <span className="label">{t('安全域：')}</span>
                      <span>{taskInfo?.biz_area_name}</span>
                    </div>
                  </div>
                  <div className="flex-column">
                    <div className="info">
                      <span className="label">{t('客户端：')}</span>
                      <span>{taskInfo?.hostname}</span>
                    </div>
                  </div>
                  <div className="flex-column">
                    <div className="info">
                      <span className="label">{t('任务模板：')}</span>
                      <span
                        className="template-name"
                        onClick={() => {
                          setDetailModal({
                            visible: true,
                            id: taskInfo?.task_id,
                            result_id: taskInfo?.result_id,
                          })
                        }}
                      >
                        {taskInfo?.template_name}
                      </span>
                    </div>
                  </div>
                  <div className="flex-column">
                    <div className="info">
                      <span className="label">{t('上传超时：')}</span>
                      <span>{taskInfo?.timeout}</span>
                    </div>
                  </div>
                  <div className="info">
                    <span className="label">{t('执行类型：')}</span>
                    {taskInfo?.scheduler_type > 2 ? (
                      <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <div
                          style={{
                            border: '1px solid #D9D9D9',
                            borderRight: 0,
                            borderRadius: '6px 0 0 6px',
                            padding: '7px',
                          }}
                        >
                          {taskInfo?.scheduler_type === 3 && t('每日')}
                          {taskInfo?.scheduler_type === 4 && t('每周')}
                          {taskInfo?.scheduler_type === 5 && t('每月')}
                        </div>
                        {taskInfo.task_time_list && (
                          <Select
                            className="type-select"
                            style={{ width: 180, marginRight: 10 }}
                            defaultValue={t('点击查看')}
                          >
                            {taskInfo?.task_time_list?.map((item, index) => (
                              <Select.Option key={index} value={item}>
                                {item}
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                      </div>
                    ) : (
                      <span>
                        {taskInfo?.scheduler_type === 1 && t('立即')}
                        {taskInfo?.scheduler_type === 2 && t('预定')} &nbsp;
                        {taskInfo?.create_time}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </TaskInfoContainer>
            <TemplateParticulars
              particulars={{
                visible: detailModal?.visible || false,
                id: detailModal?.id || '',
                result_id: detailModal?.result_id || '',
              }}
              type={1}
              setParticulars={setDetailModal}
            />
            <ScheduleMessage
              title={
                <div
                  style={{
                    paddingBottom: '16px',
                    borderBottom: '1px solid #EAEDF1',
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: '16px',
                  }}
                >
                  <div style={{ display: 'flex' }}>
                    <SvgIcon width={16} height={16} name={'task-detail-schedule'} fill={'#fff'} />
                    <div style={{ marginLeft: 5, marginRight: '10px' }}>{t('进度信息')}</div>

                    {taskInfo?.is_finished === 2 ? (
                      <TableTag color="#2973FF" background="#DBE8FF" borderRadius={4}>
                        {t('进行中')}
                      </TableTag>
                    ) : taskInfo?.is_finished === 3 ? (
                      <TableTag color="#67C23A" background="#E4F7D1" borderRadius={4}>
                        {t('已完成')}
                      </TableTag>
                    ) : taskInfo?.is_finished === 4 ? (
                      <TableTag color="#F53F3F" background="#FFDCE0" borderRadius={4}>
                        {t('中断')}
                      </TableTag>
                    ) : (
                      <TableTag color="#FF9900" background="#FFEFD7" borderRadius={4}>
                        {t('停止中')}
                      </TableTag>
                    )}
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 400, display: 'flex' }}>
                    <div>
                      {t('创建时间：')} {taskInfo?.create_time || '-'}
                    </div>
                  </div>
                </div>
              }
            >
              <div className="task-card">
                <div className="leakage">
                  <div className="leakage-left">
                    <div className="title">{t('文件格式')}</div>
                    <div className="leakage-context">
                      {taskInfo?.file_format_list ? (
                        taskInfo?.file_format_list?.map((item, index) => (
                          <TableTag key={index} bgColor="#C6CAEE" background="#fff">
                            {fileTypeMap.get(item)}
                          </TableTag>
                        ))
                      ) : (
                        <div className="leakage-empty">
                          <div>{t('无')}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="leakage-center">
                    <div className="title">{t('压缩嵌套')}</div>
                    <div className="leakage-context">
                      {taskInfo?.compress_type_list ? (
                        taskInfo?.compress_type_list?.map((item, index) => (
                          <TableTag key={index} bgColor="#C6CAEE" background="#fff">
                            {compressTypeMap.get(item)}
                          </TableTag>
                        ))
                      ) : (
                        <div className="leakage-empty">
                          <div>{t('无')}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="leakage-right">
                    <div className="title">{t('外泄途径')}</div>
                    <div className="leakage-context">
                      {taskInfo?.leak_type_list ? (
                        taskInfo?.leak_type_list?.map((item, index) => (
                          <TableTag key={index} bgColor="#C6CAEE" background="#fff">
                            {leakTypeMap.get(item)}
                          </TableTag>
                        ))
                      ) : (
                        <div className="leakage-empty">
                          <div>{t('无')}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <img className="img" src={ModeCardPng} alt="" />
              </div>
              <div style={{ display: 'flex', color: '#666666' }}>
                <div style={{ fontSize: 12 }}>
                  {t('执行开始时间：')}
                  {taskInfo?.start_time || '-'}
                </div>
                <div style={{ marginLeft: 10, fontSize: 12 }}>
                  {t('结束时间：')}
                  {taskInfo?.end_time || '-'}
                </div>
              </div>
            </ScheduleMessage>
            <div className="chart">
              <div className="gauge">
                <div style={{ minWidth: '85%' }}>
                  {taskInfo?.is_finished === 4 ? (
                    <div>
                      <img
                        src={interrupt}
                        alt=""
                        style={{
                          maxWidth: '200px',
                          marginLeft: '10px',
                          marginTop: '50px',
                          marginBottom: '80px',
                        }}
                      />
                    </div>
                  ) : (
                    <ReactECharts
                      option={option1({
                        value: score,
                        title:
                          (score <= 100 && score >= 80 && t('低危')) ||
                          (score < 80 && score >= 60 && t('中危')) ||
                          (score < 60 && score >= 40 && t('高危')) ||
                          (score < 40 && t('严重')) ||
                          '',
                      })}
                    />
                  )}
                </div>
                <div className="tag">{t('安全评分')}</div>
              </div>
            </div>
          </div>
        </Collapse.Panel>
      </CollapsibleCard>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Show
          onClick={() => setCollapse(collapse.length === 0 ? ['1'] : [])}
          visible={collapse.length > 0}
        >
          <div>{collapse.length > 0 ? t('收起') : t('展开')}</div>
          <IconFont className="icon" type="icon-gengduo2" />
        </Show>
      </div>
    </>
  )
}
export default TaskInfo
const TaskInfoContainer = styled(Card)`
  width: calc(32% - 11px);
  background: #f8f9fb;
  border-radius: 8px;
  border: 0;
  .label {
    display: inline-block;
    width: 90px;
    color: #86909c;
    margin: 12px 0;
  }
  .template-name {
    color: #4238c9;
    border-bottom: 1px solid #4238c9;
    cursor: pointer;
  }
  .type-select {
    .ant-select-selector {
      border-radius: 0 6px 6px 0;
    }
  }
  .flex-column {
    display: flex;
  }
`
const ScheduleMessage = styled(Card)`
  width: 50%;
  background: #f8f9fb;
  border-radius: 8px;
  border: 0;
  .reserve {
    font-size: 12px;
    padding: 3px 7px;
    color: #ffad31;
    background: #fff3e1;
    margin-left: 10px;
    border-radius: 9px;
  }
  .underway {
    font-size: 12px;
    padding: 3px 7px;
    color: #2973ff;
    background: #e9f1ff;
    margin-left: 10px;
    border-radius: 9px;
  }
  .accomplish {
    font-size: 12px;
    padding: 3px 7px;
    color: #67c23a;
    background: #f2f9eb;
    margin-left: 10px;
    border-radius: 9px;
  }
  .task-card {
    position: relative;
    height: 160px;
    border-radius: 6px;
    margin-top: 16px;
    margin-bottom: 16px;
    .img {
      z-index: 1;
      width: 100%;
      height: 100%;
    }
    .leakage {
      z-index: 2;
      position: absolute;
      width: 100%;
      display: flex;
      justify-content: space-around;
      .leakage-left,
      .leakage-center,
      .leakage-right {
        width: 30%;
        height: 100%;
        margin-top: 14px;
        .title {
          font-weight: bold;
          margin-bottom: 16px;
        }
        .leakage-context {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
        .leakage-empty {
          height: 80px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #666;
        }
      }
      .leakage-center .leakage-context {
        padding-left: 10%;
      }
      .leakage-right .leakage-context {
        padding-left: 5%;
      }
    }
    .item {
      width: 30%;
    }
  }
  .progress {
    padding: 12px 10px;
    .progress-list {
      width: 100%;
      display: flex;
      cursor: pointer;
      align-items: center;
      height: 32px;
      line-height: 32px;
      padding: 0 10px;
      margin-bottom: 4px;
      background: #f7f7f7;
      border-radius: 6px;
      justify-content: space-between;
      transition: all 0.2s;
      &:hover {
        background: #e7e9f3;
      }
    }
    .progress-list-left {
      display: flex;
      align-items: center;
      width: 70%;
      .payload-content {
        width: 60%;
        height: 30px;
        margin: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
    }
  }
  .send-error {
    font-size: 12px;
    padding: 4px 8px;
    border: 1px solid #f98388;
    color: #f5222d;
    background-color: #fee4e5;
    display: flex;
    align-items: center;
    border-radius: 6px;
    height: 20px;
    margin-right: 6px;
  }
  .send-succeed {
    font-size: 12px;
    padding: 4px 8px;
    border: 1px solid #abc6ff;
    color: #6f9fff;
    background-color: #e9f0ff;
    display: flex;
    align-items: center;
    border-radius: 6px;
    height: 20px;
    margin-right: 6px;
  }
  .static {
    font-size: 12px;
    padding: 0px 6px;
    color: #d0011c;
    line-height: 18px;
    background: #f5d9da;
    border-radius: 9px;
    margin-right: 10px;
  }
  .dynamic {
    font-size: 12px;
    padding: 0px 6px;
    color: #645aff;
    line-height: 18px;
    background: #e0ddff;
    border-radius: 9px;
    margin-right: 10px;
  }
`
interface IconProps {
  active: string
}
const Icon = styled(IconFont)<IconProps>`
  margin-left: 16px;
  transition: all 0.3s;
  font-size: 13px;
  transform: ${props => (props.active === '1' ? 'rotateX(0)' : 'rotateZ(180deg)')};
`
const CollapsibleCard = styled(Collapse)`
  border-radius: 6px;
  overflow: hidden;
  border: 0 !important;
  .ant-collapse-header-text {
    width: 100%;
  }
  .ant-collapse-header,
  .ant-collapse-content-box {
    background: #fff !important;
  }
  .ant-collapse-content {
    border: 0 !important;
  }
  .task-message {
    display: flex;
    margin-bottom: 18px;
  }
  .ant-card-head,
  .ant-card-body {
    padding-left: 20px;
    padding-right: 16px;
  }
  .ant-collapse-item {
    border-bottom: 0px !important;
  }
  .chart {
    width: 15%;
    .gauge {
      height: 250px;
      min-width: 25%;
      display: flex;
      align-items: center;
      flex-direction: column;
      .tag {
        position: relative;
        top: -17%;
        text-align: center;
        font-size: 14px;
        color: #73a0fa;
        line-height: 24px;
        width: 92px;
        height: 24px;
        background: rgba(115, 160, 250, 0.1);
        border-radius: 4px;
        border: 1px solid #73a0fa;
      }
    }
  }
`
interface ShowProps {
  visible: boolean
}
const Show = styled.div<ShowProps>`
  width: 130px;
  height: 20px;
  background-color: #e7e9f3;
  clip-path: polygon(0 0, 35px 100%, calc(100% - 35px) 100%, 100% 0);
  cursor: pointer;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  color: #4238c9;
  .icon {
    rotate: ${props => (props.visible ? ' 270deg' : '90deg')};
  }
`
